import React, { useState, FC } from "react";
import { HiMenuAlt3 } from "react-icons/hi";
import { FiLogOut } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import { SIDEBAR_LINKS } from "../../lib/constants/links";

const Sidebar: FC = () => {
  const [open, setOpen] = useState<boolean>(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    navigate("/auth/login");
  };

  return (
    <div
      className={`bg-gray-300 fixed top-0 left-0 h-screen ${
        open ? "w-72" : "w-16 bg-opacity-50"
      } duration-500 text-gray-100 px-4 z-50`}
    >
      <div className="py-5 flex justify-end">
        <HiMenuAlt3
          size={26}
          className="cursor-pointer text-white"
          onClick={() => setOpen(!open)}
        />
      </div>

      <div className="mt-10 overflow-y-auto h-[calc(100vh-80px)] sidebar-scroll">
        <div className="flex flex-col gap-4">
          {SIDEBAR_LINKS.map((menu, i) => (
            <Link
              to={menu.path}
              key={i}
              className={`${"mt-5"} group flex items-center text-gray-800 hover:text-gray-00 text-sm gap-3.5 font-medium p-2 hover:bg-white rounded-md`}
            >
              <div>{React.createElement(menu.icon, { size: "20" })}</div>
              <h2
                className={`whitespace-pre duration-500 ${
                  !open &&
                  "opacity-0 hover:text-white translate-x-28 overflow-hidden"
                }`}
              >
                {menu.name}
              </h2>
              <h2
                className={`${
                  open && "hidden"
                } absolute left-48 bg-white font-semibold whitespace-pre text-gray-900 rounded-md drop-shadow-lg px-0 py-0 w-0 overflow-hidden group-hover:px-2 group-hover:py-1 group-hover:left-14 group-hover:duration-300 group-hover:w-fit`}
              >
                {menu.name}
              </h2>
            </Link>
          ))}
          {/* <div
            className="group flex items-center text-gray-800 hover:text-gray-900  gap-3.5 font-medium p-2 hover:bg-white rounded-md mt-auto cursor-pointer"
            onClick={handleLogout}
          >
            <div>
              <FiLogOut size={26} />{" "}
            </div>
            <h2
              className={`whitespace-pre duration-500 ${
                !open && " hover:text-white translate-x-28 overflow-hidden"
              }`}
            >
              Logout
            </h2>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
